import { useId, useState, type ReactNode } from 'react'
import './auth.css'

export default function AuthLayout({ children }: { children: ReactNode }) {
  return <main className="auth-page">
    <aside className="auth-story" aria-label="Wortelogy">
      <a href="https://wortelogy.com" className="auth-brand"><img src="/brand/wortelogy-logo.png" alt="Wortelogy" /></a>
      <div className="auth-story-content">
        <p className="auth-eyebrow">YOUR OPERATION, CONNECTED</p>
        <h2>The system every food business <span>deserves.</span></h2>
        <p className="auth-story-copy">Connected ordering and operations, made accessible to food businesses of every size.</p>
      </div>
      <p className="auth-story-footer">Every Team. Every Customer. Every Business.</p>
    </aside>
    <section className="auth-panel">
      <header className="auth-panel-header"><a href="https://wortelogy.com" className="auth-mobile-brand"><img src="/brand/wortelogy-logo.png" alt="Wortelogy" /></a><a href="https://wortelogy.com">Back to website <span aria-hidden="true">↗</span></a></header>
      <div className="auth-card">{children}</div>
      <footer className="auth-panel-footer"><a href="https://wortelogy.com/demo">Talk to our team ↗</a></footer>
    </section>
  </main>
}

export function PasswordField({ value, onChange, autoComplete = 'current-password' }: { value: string; onChange: (value: string) => void; autoComplete?: 'current-password' | 'new-password' }) {
  const [visible, setVisible] = useState(false)
  const id = useId()
  return <div className="auth-label"><label htmlFor={id}>Password</label><div className="auth-password"><input id={id} className="auth-input" required type={visible ? 'text' : 'password'} value={value} onChange={e => onChange(e.target.value)} autoComplete={autoComplete} /><button type="button" aria-label={visible ? 'Hide password' : 'Show password'} aria-pressed={visible} onClick={() => setVisible(!visible)}>{visible ? 'Hide' : 'Show'}</button></div></div>
}
